(ns practitest.frontend.components2.dashboard.transforms.stacked-progress-bar
  (:require [practitest.frontend.components2.dashboard.transforms.stacked-bar :as sb]
            [practitest.frontend.components2.dashboard.schema :as sc]
            [practitest.frontend.components2.dashboard.helpers :as h]))

(def StackedProgressBarItem
  [:map
   [:date  inst?]
   [:group :string]
   [:value number?]])

(def StackedProgressBarSeriesData
  [:map
   [:chart/data [:vector StackedProgressBarItem]]
   [:chart/inactive-groups [:vector [:string]]]
   [:chart/categories-count :int]
   [:chart/series [:vector [:string]]]
   [:chart/x-label-visible-step [:maybe :int]]])

(defn transform
  {:malli/schema
   [:=> [:cat [:map
               [:chart/data sc/SeriesInstCategories]
               [:chart/cell-width {:optional true} [:maybe [:enum :regular :double :triple]]]]]
    StackedProgressBarSeriesData]}
  [{{:keys [series categories]} :chart/data
    :chart/keys                 [toggle-legend cell-width]
    :or                         {toggle-legend {}}
    :as                         chart}]
  (let [active?              #(toggle-legend % true)
        a-series             (h/active-series series active?)
        categories-count     (count categories)
        x-label-visible-step (h/x-label-visible-step categories-count cell-width)
        inactive-groups      (->> series
                                  (remove #(some #{(:name %)} (map :name a-series)))
                                  (mapv :name))]

    (merge chart
           {:chart/data
            (vec
              (mapcat (fn [idx category]
                        (map (fn [{group :name data :data}]
                               {:date  category
                                :group group
                                :value (nth data idx 0)})
                             a-series))
                      (range categories-count)
                      categories))

            :chart/inactive-groups      inactive-groups
            :chart/categories-count     categories-count
            :chart/series               (mapv :name series)
            :chart/x-label-visible-step x-label-visible-step})))